import React, { useState } from "react";

import { useAlert, useConfirmationDialog, useApi } from "@/";
import {
  Button,
  FileUploadInput,
} from "@/components";
const UploadForm = ({ setAlertOpen = false }) => {
  const { alert, AlertDialog } = useAlert();
  const { confirm, ConfirmationModal } = useConfirmationDialog();
  const { callApi, loading } = useApi();
  const [error, setError] = useState("");
  const [files, setFiles] = useState(null);

  const handleFileChange = (file) => {
    setFiles(file);
    setError("");
  };

  const handleUpload = async () => {
    if (!files) {
      await alert("Please select a file to upload.");
      return;
    }
    await confirm("Are you sure you want to upload this file?");
    try {
      const formData = new FormData();
      for (const file of files) {
        formData.append(file.name.replace(/\.[^/.]+$/, ""), file);
      }
      const response = await callApi("/admin/uploadDocs", "POST", formData,null, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (!response.success) {
        await alert("Failed to upload file.");
        return;
      }


      // Create CSV content with header and file details
      const csvHeader = "File Name,File URL";
      const csvRows = response.data.map((item) => {
        const fileName = item.fileName || "";
        const url = item.url || "";
        return `"${fileName.replace(/"/g, '""')}","${url.replace(/"/g, '""')}"`;
      });
      const csvContent = [csvHeader, ...csvRows].join('\n');
      
      // Create a Blob with the CSV content
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      
      // Create a download link and trigger download
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      const _d = new Date();
      const _month = _d.toLocaleString('en-US', { month: 'short' });
      const _day = String(_d.getDate()).padStart(2, '0');
      const _year = _d.getFullYear();
      const _time = _d.toLocaleString('en-US', { hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true }).replace(/:/g, '-').replace(' ', '');
      link.setAttribute('download', `uploaded_files_${_month}-${_day}-${_year}_at_${_time}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      
      // Clean up resources
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);

      setFiles(null);
      setError("");

      await alert("File uploaded successfully.");
      setAlertOpen(false);
    } catch (error) {
      console.error("Error uploading file:", error);
      await alert("Failed to upload file.");
    }
  };

  return (
    <div className="flex flex-col gap-2 ">
      <FileUploadInput
        id="upload-image"
        label="Upload images to get links"
        disabled={false}
        error={error}
        multiple={true}
        accept="image/*, application/pdf"
        className="max-w-full p-0"
        onChange={(file) => handleFileChange(file)} // Pass selected file
      />
      <div className="w-full">
        <Button
          className="h-12 w-full mt-4"
          size="md"
          onClick={handleUpload}
          isLoading={loading}
        >
          Upload 
        </Button>
      </div>
      <AlertDialog />
      <ConfirmationModal />
    </div>
  );
};

export default UploadForm;
